import { UPDATE_SCHEDULE } from '../actions/calendar-actions';

export default function calendarReducer(state = '', { type, payload }) {
    console.log(type, payload);
    switch (type) {
        case UPDATE_SCHEDULE :
            console.log(UPDATE_SCHEDULE)
            return payload.calendar || null;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/calendar-reducer.js